import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa"; // ← dodaj ovu biblioteku ako je nemaš

const MachineList = () => {
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMachines();
  }, []);

  const fetchMachines = async () => {
    try {
      const res = await axios.get("https://modularobjects.com/checkout/api/machines");
      setMachines(res.data);
    } catch (err) {
      console.error("Greška pri dohvatanju mašina:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">📋 Lista mašina</h2>
        <Link to="/machines/new" className="bg-blue-600 text-white px-4 py-2 rounded shadow">
          ➕ Dodaj novu
        </Link>
      </div>

      {loading ? (
        <p>Učitavanje...</p>
      ) : machines.length === 0 ? (
        <p>Nema unetih mašina.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          {machines.map((m) => (
            <Link
  key={m.id}
  to={`/machines/${m.id}/edit`}
  className="border rounded-lg shadow-sm p-4 flex gap-6 items-start hover:bg-gray-50 transition"
>
              {m.image_url ? (
                <img
  src={`https://modularobjects.com/checkout/${m.image_url}`}
  alt={m.name}
  className="w-32 h-32 object-contain rounded border"
/>
              ) : (
                <div className="w-32 h-32 bg-gray-100 flex items-center justify-center text-sm text-gray-500 border rounded">
                  Nema slike
                </div>
              )}

              <div className="flex-1">
                <h3 className="text-xl font-semibold">{m.name}</h3>
                <p className="text-sm text-gray-700">
                  <strong>Materijal:</strong> {m.material} | <strong>Proces:</strong> {m.process}
                </p>
                <p className="text-sm text-gray-600">
                  Tip: {m.type_name || "Nepoznato"} | Proizvođač: {m.manufacturer_name || "Nepoznato"}
                </p>

                {m.spec_url && (
                  <a
                    href={m.spec_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-blue-600 hover:underline mt-2 text-sm"
                  >
                    <FaFilePdf className="text-red-600" />
                    Pogledaj dokumentaciju
                  </a>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default MachineList;
